import React from "react";

import { ISearchResult } from "types";

import { normalizeSearchResult } from "utils";
import { HorizontalTeaser } from "components";

interface SearchResultsProps {
  results: ISearchResult[];
  currentPage?: number;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  currentPage = 1,
}) => (
  <ul className="horizontal-teaser-container is-light">
    {results.map((result, index) => (
      <li>
        <HorizontalTeaser
          key={`search-result-${currentPage}-${index}`}
          {...normalizeSearchResult(result)}
          theme="light"
        />
      </li>
    ))}
  </ul>
);
